import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2_Register } from '@/api/model/interfaces';

export default class PackageKS2RegisterOdata extends OdataManager<PackageKS2_Register> {}
